import { render, staticRenderFns } from "./inspectionDangerDetail.vue?vue&type=template&id=782011c0&scoped=true&"
import script from "./inspectionDangerDetail.vue?vue&type=script&lang=js&"
export * from "./inspectionDangerDetail.vue?vue&type=script&lang=js&"
import style0 from "./inspectionDangerDetail.vue?vue&type=style&index=0&id=782011c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782011c0",
  null
  
)

export default component.exports